import axios from "axios";

import baseDomain, { notificationAPI } from "../../Constants/apiRoutes";

export const createNotification = (data) => {
  return axios.post(`${baseDomain}${notificationAPI}`, data);
};